export const enum ModalPane {
    CreateApp = 'createApp',
    Templates = 'Templates',
}
